// adobe-events.js
window.adobeDataLayer = window.adobeDataLayer || [];

document.addEventListener("DOMContentLoaded", function () {
  // Identify current page from body attribute
  const pageType = document.body.dataset.pageType || "Home";
  const pageName = document.title || pageType;

  // Example: dynamic customer data from global JS (replace with actual values)
  const customer = window.customer || {
    id: "",
    email: "",
    phone: "",
    isLoggedIn: false
  };

  const custData = {
    custId: customer.id,
    emailID_plain: customer.email,
    mobileNo_plain: customer.phone,
    loginStatus: customer.isLoggedIn ? "logged in" : "guest"
  };

  // Landing Event (for every page)
  adobeDataLayer.push({
    event: "landed",
    eventInfo: { eventName: "landed" },
    custData,
    page: {
      pageName: pageType === "PDP" ? `PDP:${pageName}` : pageName,
      pageType,
      language: "en_IN"
    }
  });
});

// General Link Click Tracker
function trackLinkClick({ linkName, linkPosition, linkType, pageInfo = {}, custData = {} }) {
  adobeDataLayer.push({
    event: "link_click",
    eventInfo: { eventName: "link_click" },
    linkInfo: {
      linkName,
      linkPosition,
      linkType
    },
    custData,
    page: pageInfo
  });
}

// Buy All Together Tracker
function trackBuyAllTogether({ pageInfo, custData, priceSummary, productList }) {
  adobeDataLayer.push({
    event: "Cart",
    eventInfo: { eventName: "Cart" },
    linkInfo: {
      linkName: "Buy All Together",
      linkPosition: "Frequently Bought Together",
      linkType: "Button"
    },
    custData,
    priceSummary,
    page: pageInfo,
    product: productList
  });
}

// Product Click Tracker
function trackProductClick({ linkPosition, linkType, pageInfo, custData, productList }) {
  adobeDataLayer.push({
    event: "product_click",
    eventInfo: { eventName: "product_click" },
    linkInfo: {
      linkName: "Product Click",
      linkPosition,
      linkType
    },
    custData,
    page: pageInfo,
    product: productList
  });
}

// Add to Cart Tracker
function trackAddToCart({ linkPosition, pageInfo, custData, productList }) {
  adobeDataLayer.push({
    event: "Cart",
    eventInfo: { eventName: "Cart" },
    linkInfo: {
      linkName: "Add To Cart",
      linkPosition,
      linkType: "Button"
    },
    custData,
    page: pageInfo,
    product: productList
  });
}

// Buy Now Tracker
function trackBuyNow({ linkPosition, pageInfo, custData, productList }) {
  adobeDataLayer.push({
    event: "link_click",
    eventInfo: { eventName: "link_click" },
    linkInfo: {
      linkName: "Buy Now",
      linkPosition,
      linkType: "Button"
    },
    custData,
    page: pageInfo,
    product: productList
  });
}
